enum userSettingEnum{
    SensorColumnAQS = 'SensorColumn.AQS',
    SensorColumnFDS = 'SensorColumn.FDS',
    SensorColumnAQS2 = 'SensorColumn.AQS2',
    SensorColumnFDS2 = 'SensorColumn.FDS2',
    SensorColumnTIS = 'SensorColumn.TIS',
    SensorColumnPS = 'SensorColumn.PS',
    SensorColumnAQS3 = 'SensorColumn.AQS3',
    SensorColumnIAQ = 'SensorColumn.IAQ',
    LineChartColumnAQS = 'LineChartColumn.AQS',
    LineChartColumnFDS = 'LineChartColumn.FDS',
    LineChartColumnAQS2 = 'LineChartColumn.AQS2',
    LineChartColumnFDS2 = 'LineChartColumn.FDS2',
    LineChartColumnTIS = 'LineChartColumn.TIS',
    LineChartColumnPS = 'LineChartColumn.PS',
    LineChartColumnAQS3 = 'LineChartColumn.AQS3',
    LineChartColumnIAQ = 'LineChartColumn.IAQ',
    PageLimit = 'Pager.PageSize',
    DataRange="DataRange",
    DataRangeIAQ="DataRangeIAQ"
}
export default userSettingEnum